import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
//
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
//
import TopPanel from "./topPanel/TopPanel";
import DisplayArea from "./displayArea/DisplayArea";
import AnalyticsResult from "./analysis/AnalyticsResult";
import DiaryInfo from "./diaryInfo/DiaryInfo";
import DiaryInfoIconTool from "./widget/DiaryInfoIconTool";
import AnalyticsIconTool from "./widget/AnalyticsIconTool";
import FullScreenIconTool from "./widget/FullScreenIconTool";
//
import { StoreContext } from "../../../../store/StoreProvider";
// config,utils
// style
import { drawerWidth, SNA_DISPLAY_DIV_ID, SNA_MAIN_ID } from "../../config";
import Act from "../../../../store/actions";

// fixme: 待 theme provider 建立好之後, 設定 transition
const StyledMainBox = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexGrow: 1,
  // padding: theme.spacing(3),
  // transition: theme.transitions.create("margin", {
  //   easing: theme.transitions.easing.sharp,
  //   duration: theme.transitions.duration.leavingScreen,
  // }),
  marginLeft: `-${drawerWidth}px`,
  // ...(open && {
  //   transition: theme.transitions.create("margin", {
  //     easing: theme.transitions.easing.easeOut,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  //   marginLeft: 0,
  // }),
  ...(open && {
    marginLeft: 0,
  }),
  height: "100%",
  padding: "16px 24px",
  backgroundColor: "#f7f8fa",
}));

const StyledFullScreenWrapper = styled(
  Box,
  {}
)(({ theme }) => ({
  position: "relative",
  height: 0,
  top: "24px",
  right: -15,
}));

const Main = () => {
  // props
  // route,intl
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sidebar } = state.sna;
  // local state
  //

  useEffect(() => {
    dispatch({
      type: Act.SNA_APPLY_FETCH_DATASET,
      payload: true,
    });
  }, []);

  return (
    <StyledMainBox open={sidebar.open} className={SNA_MAIN_ID}>
      <Grid container direction="column" justifyContent="space-between">
        <Grid item>
          {/* 工具列 */}
          <TopPanel />
        </Grid>
        <Grid item>
          <Box display="flex" justifyContent="flex-end">
            <StyledFullScreenWrapper
              display="flex"
              flexDirection="column"
              width={80}
              rowGap={1}
            >
              {/* 全螢幕功能按鈕 */}
              <FullScreenIconTool />
              {/* 事件分類表 */}
              <DiaryInfoIconTool />
              {/* 數據分析 */}
              <AnalyticsIconTool />
            </StyledFullScreenWrapper>
          </Box>
        </Grid>
        <Grid item>
          {/* 數據分析結果 */}
          <AnalyticsResult />
        </Grid>
        <Grid item>
          {/* 日誌詳細資訊 */}
          <DiaryInfo />
        </Grid>
        <Grid item>
          {/* SNA 繪圖區 */}
          <DisplayArea />
        </Grid>
      </Grid>
    </StyledMainBox>
  );
};

Main.propTypes = {};

Main.defaultProps = {};

export default Main;
